/** Letters from the Arabic Unicode blocks (Arabic, Supplement, Extended-A, Presentation Forms). */
const ARABIC_LETTER = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/g;
const LATIN_LETTER = /[A-Za-z]/g;

/** Strips tags and entities so only the visible text is measured. */
function visibleText(html: string | null | undefined): string {
  return (html ?? '').replace(/<[^>]*>/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ');
}

/** True when most of the letters in the HTML are Arabic script. */
export function isMostlyArabic(html: string | null | undefined): boolean {
  const text = visibleText(html);
  const arabic = text.match(ARABIC_LETTER)?.length ?? 0;
  const latin = text.match(LATIN_LETTER)?.length ?? 0;

  return arabic > latin;
}

/**
 * Returns the content with `contentEn`/`contentAr` swapped back when the backend sent them the
 * wrong way round (English text in `contentAr` and Arabic text in `contentEn`). Content that is
 * already correct, empty, or ambiguous is returned unchanged.
 */
export function withCorrectedLanguages<T extends { contentEn: string; contentAr: string }>(
  content: T
): T {
  if (!content?.contentEn || !content?.contentAr) {
    return content;
  }

  const enIsArabic = isMostlyArabic(content.contentEn);
  const arIsArabic = isMostlyArabic(content.contentAr);

  if (enIsArabic && !arIsArabic) {
    return { ...content, contentEn: content.contentAr, contentAr: content.contentEn };
  }

  return content;
}
